import { ServiceProviderId } from "./ServiceProviderId";
import { ServiceProviderName } from "./ServiceProviderName";
import { ServiceProviderSpId } from "./ServiceProviderSpId";
import { ServiceProviderSharedPassword } from "./ServiceProviderSharedPassword";

const ServiceProviderType = Symbol();

export class ServiceProvider {
    [ServiceProviderType]: any;
    readonly id: ServiceProviderId;
    readonly name: ServiceProviderName;
    readonly spId: ServiceProviderSpId;
    readonly sharedPassword: ServiceProviderSharedPassword;

    private constructor(
        id: ServiceProviderId,
        name: ServiceProviderName,
        spId: ServiceProviderSpId,
        sharedPassword: ServiceProviderSharedPassword
    ) {
        this.id = id;
        this.name = name;
        this.spId = spId;
        this.sharedPassword = sharedPassword;
    }

    static from(
        id: ServiceProviderId,
        name: ServiceProviderName,
        spId: ServiceProviderSpId,
        sharedPassword: ServiceProviderSharedPassword
    ): ServiceProvider {
        return new ServiceProvider(id, name, spId, sharedPassword);
    }

    static fromIdName(
        id: ServiceProviderId,
        name: ServiceProviderName
    ): ServiceProvider {
        return new ServiceProvider(id, name, ServiceProviderSpId.fromNothing(), ServiceProviderSharedPassword.fromNothing());
    }
}

export type ServiceProviderJson = {
    id: string,
    name: string,
    spId: string,
    sharedPassword: string
};

export const serviceProviderInitialState = {
    id: "",
    name: "",
    spId: "",
    sharedPassword: ""
};
